import type { ReactNode } from 'react'

import { RedactionProvider } from '../../../../core'
import { useDisplaySettings } from '../hooks/useDisplaySettings'

interface DemoModeRedactionProviderProps {
  children: ReactNode
}

export function DemoModeRedactionProvider({
  children,
}: DemoModeRedactionProviderProps) {
  const [displaySettings] = useDisplaySettings()
  const isDemoModeActive =
    displaySettings.demo_mode?.account_slug !== null &&
    displaySettings.demo_mode?.account_slug !== undefined

  return (
    <RedactionProvider isRedactionActive={isDemoModeActive}>
      {children}
    </RedactionProvider>
  )
}
